import React from 'react';
import './App.css';
import AppRouter from "./Router";

const App: React.FC = () => {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
